module.exports = __webpack_public_path__ + "static/media/warner.4336e6f6.svg";